import personalFincancingIcon from "@/assets/images/landing_page/ic-personal-financing.svg";
import personalFutureSavingsIcon from "@/assets/images/landing_page/ic-personal-future-savings.svg";
import personalHomeOwningIcon from "@/assets/images/landing_page/ic-personal-home-owning.svg";
import personalEducationIcon from "@/assets/images/landing_page/ic-personal-education.svg";
import companyStartUpIcon from "@/assets/images/landing_page/ic-company-start-up.svg";
import companyCashManagement from "@/assets/images/landing_page/ic-company-cash-management.svg";
import companyBusinessExpansion from "@/assets/images/landing_page/ic-company-business-expansion.svg";
import companySalarySolution from "@/assets/images/landing_page/ic-company-salary-rupiah.svg";

export const efundingProsCardList = {
  personal: [
    {
      id: 1,
      label: "Pengelolaan Keuangan",
      icon: personalFincancingIcon,
    },
    {
      id: 2,
      label: "Investasi Masa Depan",
      icon: personalFutureSavingsIcon,
    },
    {
      id: 3,
      label: "Kepemilikan Aset",
      icon: personalHomeOwningIcon,
    },
    {
      id: 4,
      label: "Modal Usaha",
      icon: personalEducationIcon,
      comingSoon: true,
    },
  ],
  company: [
    {
      id: 1,
      label: "Startup dan Perusahaan",
      icon: companyStartUpIcon,
    },
    {
      id: 2,
      label: "Peningkatan Likuiditas",
      icon: companyCashManagement,
    },
    {
      id: 3,
      label: "Pengembangan Bisnis",
      icon: companyBusinessExpansion,
    },
    {
      id: 4,
      label: "Dana Cadangan",
      icon: companySalarySolution,
    },
  ],
};



// WEBPACK FOOTER //
// ./src/utils/efunding-pros-card-list.js